import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = "G-1JXD87S7DF";

// The checkout page hands the browser to Airwallex, so no third-party script may run on it (PCI SAQ A).
const isCheckout = (pathname) => pathname === "/checkout" || pathname.startsWith("/checkout/");

// Load gtag.js once, on the first page that isn't checkout.
function loadGtag() {
  if (window.gtag) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false });
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
}

function useGoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;

    if (isCheckout(location.pathname)) {
      // Arrived in-app with analytics already loaded: reload so checkout starts in a clean page.
      if (window.gtag) window.location.reload();
      return;
    }

    loadGtag();
    // Send page view (we handle SPA route changes)
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);
}

export default function GoogleAnalytics() {
  useGoogleAnalytics();
  return null;
}
